import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";

@Injectable()
export class UsuarioApiService {

    constructor(
        private _restService: RestService
    ) { }

    onGetTokenByCookie(cookie: string, done: any) {
        this._restService.onGetSemToken(apiName + '/credenciais/token/' + cookie, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/shared/usuario-api.service.ts
 **/